import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-photo-add",
  templateUrl: "./med-icon-photo-add.component.html",
})
export class MedIconPhotoAddComponent extends SvgMixinComponent {}
